var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",staticClass:"c-cta",attrs:{"rel":"noreferrer","href":_vm.block.meta.ctaLink,"target":"_blank","title":_vm.block.meta.ctaLink}},[_vm._v(" "+_vm._s(_vm.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }